// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jez5","label":"styles_label__3ZStn"};